<template>
  <div v-if="value" class="overlay">
    <div class="modal">
      <div class="modal__title">
        <span>License Expired</span>
      </div>
      <div class="modal__body">
        <p>{{ message }}</p>
        <div class="modal__actions">
          <button class="modal__button" @click="$emit('input', false)">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "License expired. Please renew license to use the functionality.",
    },
  },
};
</script>

<style lang="postcss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  width: 520px;
  max-width: 90vw;
  box-shadow: 1px 2px 8px rgba(153, 155, 168, 0.2);
  border-radius: 6px;
  @apply bg-white;
}

.modal__title {
  color: #7c2d12;
  background: #fff7ed;
  border-bottom: 1px solid #fed7aa;
  @apply flex items-center justify-between p-4 font-bold;
}

.modal__body {
  @apply p-4 text-sm text-gray-700;
}

.modal__actions {
  @apply mt-4 flex justify-end;
}

.modal__button {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
}
</style>
